module.exports = __webpack_public_path__ + "img/CENTRIF.b54803f2.jpg";